import {
  aMatchList,
  aMatchListItemPage,
  aMatchListPage,
  mockMatchListsOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const MATCH_LIST_DATA = {
  name: `Test Match List ${Date.now()}`,
  description: `Test match list description`,
  timeToLive: 3,
  updatedDescription: `Test match list description updated`,
  updatedTimeToLive: 4,
};

export const matchListHandler = ({
  id,
  name,
  description,
  timeToLiveInSeconds,
}) => ({
  __typename: 'Query',
  matchLists: aMatchListPage({
    hasNextPage: false,
    objects: [
      aMatchList({
        defaultTtl: timeToLiveInSeconds,
        description,
        id,
        items: aMatchListItemPage({
          hasNextPage: false,
          objects: [],
          total: 0,
        }),
        name,
        targetColumn: '1',
      }),
    ],
    total: 1,
  }),
  matchListItemCount: 1,
  matchListItemLimit: 5,
});

export const handlers = [
  mockMatchListsOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          matchLists: aMatchListPage({
            hasNextPage: false,
            objects: [],
            total: 0,
          }),
          matchListItemCount: 0,
          matchListItemLimit: 1,
        },
      });
    }
  ),
];
